<template>
  <section class="single-play-post-area mt-10">
    <div class="container custom-container">
      <div class="single-play-box">
        <div class="single-play-post-slider position-relative">
          <span
            @click="playSliderPrev"
            class="prev slick-arrow"
            style="display: block"
          >
            <i class="fal fa-angle-left"></i>
          </span>
          <slider v-if="playPostDatas.length" :settings="playPostSettings" ref="playPost">
            <template v-for="(data, index) in playPostDatas">
              <!-- 绑定自定义类 -->
              <div :key="index" class="large-screen-padding">
                <overlay-card :datas="data" stype="big" />
              </div>
            </template>
          </slider>
          <span
            @click="playSliderNext"
            class="next slick-arrow"
            style="display: block"
          >
            <i class="fal fa-angle-right"></i>
          </span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { getAds } from '@/api/placement';
import config from '@/config';
import playPostDatas from "../Data/singlePlay";
import Slider from "../Helpers/Slider.vue";
import OverlayCard from "../Utility/Cards/OverlayCard.vue";
export default {
  components: { OverlayCard, Slider },
  inject: ['dataWrapper', 'fetchStatus'],
  data: () => ({
    //playPost
    playPostDatas: playPostDatas.data,
    playPostSettings: {
      arrows: false,
      slidesToShow: 2,
      slideToScroll: 1,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slideToScroll: 1,
          },
        },
      ],
    },
  }),
  created() {
    this.fetchAdsData();
  },
  watch: {
    'fetchStatus.isFetched': {
      handler(newVal) {
        if (newVal) {
          // this.playPostDatas = Array.isArray(this.dataWrapper.articles) 
          //   ? this.dataWrapper.articles.filter(item => item.orgchannel === '4').slice(0, 6) 
          //   : [];
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    //playPost
    playSliderPrev() {
      this.$refs.playPost.prev();
    },
    playSliderNext() {
      this.$refs.playPost.next();
    },
    async fetchAdsData() {
      try {
        const adsResponse = await getAds(config.AD_MIDDLEDOUBLESQUAREROLLINGBANNER);
        this.playPostDatas = adsResponse.data || [];
        
        this.isLoading = false;
      } catch (error) {
        // 添加错误处理
        console.log('画廊广告加载失败:', error);
        this.isLoading = false;
      }
    }
  },
};
</script>

<style scoped>
/* 定义自定义类，仅在大屏幕尺寸应用样式 */
@media (min-width: 992px) {
  .large-screen-padding {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
</style>